import {
  aggregateSportLogs,
  formatDurationLabel,
  formatPaceLabel,
  normalizeSessionKind,
  SESSION_KINDS,
} from '../../utils/trainingSportSession';

/** Dashboard coach — avances Deportes (Running / Natación). */
export default function SportCoachDashboard({ logs = [], days = 30 }) {
  const stats = aggregateSportLogs(logs, days);

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {[
          { label: 'Sesiones', value: stats.total },
          { label: 'Running', value: stats.running },
          { label: 'Natación', value: stats.swimming },
          { label: 'Tiempo total', value: formatDurationLabel(stats.total_duration_sec) },
        ].map((k) => (
          <div key={k.label} className="rounded-xl border border-stone-200 bg-white p-3 ui-light-surface">
            <p className="text-[10px] uppercase tracking-wide text-stone-500 m-0">{k.label}</p>
            <p className="text-lg font-bold text-stone-900 m-0 mt-1">{k.value}</p>
          </div>
        ))}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <div className="rounded-xl border border-stone-200 bg-white p-3">
          <p className="text-[10px] uppercase text-stone-500 m-0">Pace medio Running</p>
          <p className="text-base font-bold m-0 mt-1">{formatPaceLabel(stats.avg_pace_sec_per_km)}</p>
        </div>
        <div className="rounded-xl border border-stone-200 bg-white p-3">
          <p className="text-[10px] uppercase text-stone-500 m-0">Zona promedio</p>
          <p className="text-base font-bold m-0 mt-1">
            {stats.avg_zone != null ? Number(stats.avg_zone).toFixed(1) : '—'}
          </p>
        </div>
        <div className="rounded-xl border border-stone-200 bg-white p-3">
          <p className="text-[10px] uppercase text-stone-500 m-0">FC promedio</p>
          <p className="text-base font-bold m-0 mt-1">
            {stats.avg_hr != null ? `${Math.round(stats.avg_hr)} ppm` : '—'}
          </p>
        </div>
      </div>

      <div className="rounded-xl border border-stone-200 bg-white overflow-hidden">
        <div className="px-3 py-2 border-b border-stone-100 bg-stone-50">
          <p className="text-sm font-bold text-stone-800 m-0">Últimas sesiones ({days}d)</p>
        </div>
        {stats.sessions.length === 0 ? (
          <p className="text-sm text-stone-600 p-4 m-0">Aún no hay registros Running / Natación.</p>
        ) : (
          <ul className="divide-y divide-stone-100 m-0 p-0 list-none">
            {stats.sessions.slice(0, 20).map((row) => {
              const kind = normalizeSessionKind(row.session_kind);
              const sl = row.sport_log || {};
              return (
                <li key={row.id || `${row.fecha}-${row.dia}`} className="px-3 py-2.5 text-sm">
                  <div className="flex flex-wrap items-center justify-between gap-2">
                    <div>
                      <span className="font-semibold text-stone-900">{row.fecha || '—'}</span>
                      <span className="ml-2 text-xs rounded-full px-2 py-0.5 bg-emerald-50 text-emerald-800 border border-emerald-100">
                        {kind === SESSION_KINDS.RUNNING ? 'Running' : 'Natación'}
                      </span>
                    </div>
                    <span className="text-xs text-stone-600">
                      {formatDurationLabel(sl.duration_sec)}
                      {sl.zone != null ? ` · Z${sl.zone}` : ''}
                      {sl.hr_avg_ppm != null ? ` · ${sl.hr_avg_ppm} ppm` : ''}
                      {kind === SESSION_KINDS.RUNNING && sl.pace_sec_per_km
                        ? ` · ${formatPaceLabel(sl.pace_sec_per_km)}`
                        : ''}
                      {kind === SESSION_KINDS.SWIMMING && sl.pace_per_100_sec
                        ? ` · ${sl.pace_per_100_sec}s/100m`
                        : ''}
                    </span>
                  </div>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
}
